// extracted by mini-css-extract-plugin
export var actions = "_1x-0";
export var actionsContainer = "_1x-7";
export var border = "_1x-1";
export var childFullHeight = "_1x-f";
export var collapse = "_1x-2";
export var content = "_1x-a";
export var contentChild = "_1x-e";
export var fullscreen = "_1x-c";
export var hasLeftRadius = "_1x-k";
export var headerContainer = "_1x-3";
export var headerRow = "_1x-5";
export var hidePadding = "_1x-b";
export var navCollapsedGap = "_1x-l";
export var noScrollX = "_1x-m";
export var noScrollY = "_1x-n";
export var noTopPadding = "_1x-i";
export var optOutTopPadding = "_1x-d";
export var pageMain = "_1x-j";
export var pageOuter = "_1x-g";
export var pagePadding = "_1x-8";
export var pageScroll = "_1x-9";
export var profile = "_1x-o";
export var profileContainer = "_1x-p";
export var profileImage = "_1x-q";
export var profileMain = "_1x-r";
export var profileSubtitle = "_1x-t";
export var profileTitle = "_1x-s";
export var showLeftPadding = "_1x-h";
export var tabsPortalSlot = "_1x-6";
export var tabsWrapper = "_1x-4";
export var title = "_1x-u";